import React from 'react';
import { useTranslation } from 'react-i18next';
import VersionCard from './VersionCard';
import './VersionSection.css';

const VersionSection = () => {
  const { t } = useTranslation();
  const v2Data = t('versions.v2', { returnObjects: true });
  const v1Data = t('versions.v1', { returnObjects: true });

  return (
    <section className="version-section">
      <div className="container">
        <div className="version-section__header">
          <h2 className="version-section__title">
            选择你的 CryptoTrader Pro 版本
          </h2>
          <p className="version-section__subtitle">
            体验全新的交易工作台，或继续使用经典版本
          </p>
        </div>

        <div className="version-cards">
          <VersionCard
            title={v2Data.title}
            description={v2Data.description}
            badges={v2Data.badges}
            features={v2Data.features}
            buttonText={v2Data.buttonText}
            buttonUrl={v2Data.buttonUrl}
            isExternal={false}
            variant="featured"
          />
          
          <VersionCard
            title={v1Data.title}
            description={v1Data.description}
            badges={v1Data.badges}
            features={v1Data.features}
            buttonText={v1Data.buttonText}
            buttonUrl={v1Data.buttonUrl}
            isExternal={true}
            variant="default"
          />
        </div>
      </div>
    </section>
  );
};

export default VersionSection;